var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66308 15.874L0.125505 8.30435C-0.0418358 8.13626 -0.0418358 7.86376 0.125505 7.69564L7.66308 0.126067C7.83042 -0.0420222 8.10176 -0.0420222 8.26914 0.126067L8.52168 0.379653C8.68903 0.547707 8.68903 0.820243 8.52168 0.988332L2.14689 7.39028H15.5714C15.8081 7.39028 16 7.58299 16 7.82068V8.17935C16 8.41703 15.8081 8.60974 15.5714 8.60974H2.14689L8.52168 15.0117C8.68903 15.1797 8.68903 15.4523 8.52168 15.6204L8.26914 15.874C8.10176 16.042 7.83042 16.042 7.66308 15.874Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortArrow);
export default __webpack_public_path__ + "static/media/ShortArrow.c969658b691a3d72de78307b4f79a4c3.svg";
export { ForwardRef as ReactComponent };